import React from 'react';
import Icon from '@amzn/awsui-components-react/polaris/icon';
import { IconVariant } from '../types';

const WarningIcon = ({
  message,
  variantType,
}: {
  message: string;
  variantType: IconVariant;
}) => (
  <>
    <Icon name="status-warning" variant={variantType} />{' '}
    <span
      style={{
        color: '#879596',
        fontStyle: 'italic',
        fontSize: '0.85em',
      }}
    >
      {message}
    </span>
    <br />
  </>
);

export default WarningIcon;
